import { Environment } from '@abp/ng.core';

const baseUrl = 'https://roadsmanagement-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://roadsmanagement-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'RoadsProjectManagement_App',
  responseType: 'code',
  scope: 'offline_access RoadsProjectManagement',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  name: 'development',
  production: false,
  application: {
    baseUrl,
    name: 'RoadsProjectManagement',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://roadsmanagement-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.RoadsProjectManagement',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
} as Environment;
